import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  CmpButton,
  CmpStatusIcon,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const WmsPhysicalStockCountDetailTblCard = ({
  data = [],
  onClick = () => {},
}) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={12} key={index}>
          <div className="easy-putaway-card">
            <Grid
              container
              spacing={0.5}
              columns={{ xs: 12, md: 12 }}
              onClick={() => {
                let items = { row: item };
                onClick(items);
              }}
            >
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Barcode
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.BarCode}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Card.ID
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.B_CardID}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Bin.Name
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.BinName}
                </Typography>
              </Grid>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Qty
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.B_Qty}
                </Typography>
              </Grid>

              
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Unit
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item?.B_Unit}
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                ReferenceNo
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item?.SuppRefNo1}
                </Typography>
              </Grid>
               
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
                  {item.ItmName}
                </Typography>
              </Grid>
            </Grid>
          
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
